import { useMemo } from "react";
import { detectBrandProfile, type BrandProfile, type BrandKey } from "@/lib/brandRegistry";

export type { BrandProfile, BrandKey };

export const detectBrand = (hostname?: string): BrandProfile =>
  detectBrandProfile(hostname);

export const useDomainBranding = (): BrandProfile =>
  useMemo(() => detectBrandProfile(), []);

// Back-compat named exports (other files import these).
export const OBC_PROFILE = detectBrandProfile("www.obriencontractingusa.com");
export const RCF_PROFILE = detectBrandProfile("www.roofcertificateflorida.com");
